import axios from 'axios';
import router from "@/router/router";

const api = axios.create({
  baseURL: process.env.VUE_APP_LOCAL_API,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401 && !window.location.pathname.startsWith('/login')) {
      const redirect = window.location.pathname + window.location.search;
      sessionStorage.setItem('redirect', redirect);
      router.push({ path: '/login' });
    }
    return Promise.reject(error);
  }
);

export default api;
